export default __webpack_public_path__ + "static/media/cusApp.0a347440.png";